class ViewingAvailabilityTable {
	constructor(target) {
		this.$table = $(target);
		this.$table.on("click", ".viewing-availability-day", event => this.onDayClick(event));
		this.$table.on("click", ".viewing-availability-hour", event => this.onHourClick(event));
		this.$table.on("change input", event => this.onChange(event));
	}

	onDayClick(event) {
		event.preventDefault();

		const $th = $(event.currentTarget).closest("th");
		const thIndex = $th.index();

		const checked = this.$table.find("tbody > tr").eq(0).find("input[type=checkbox]").eq(thIndex - 1).prop("checked");

		this.$table.find("tbody > tr").each((trIndex, element) => {
			$(element).find("td").eq(thIndex).find("input[type=checkbox]").prop("checked", !checked).trigger("change");
		});
	}

	onHourClick(event) {
		event.preventDefault();

		const $tr = $(event.currentTarget).closest("tr");
		const checked = $tr.find("input[type=checkbox]").prop("checked");
		$tr.find("input[type=checkbox]").prop("checked", !checked).trigger("change");
	}

	onChange(event) {
		const hours = this.$table.find("input:checked").length;
		this.$table.find("tfoot td").text(__("Hours Selected: %d", hours));
	}
}
